import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const About = () => {
  const { t } = useTranslation('about');
  const { language } = useLanguage();

  return (
    <div className="about-page">
      <SEO 
        title="About EWANDS - Leading AI Software Company in Malaysia"
        description="Learn about EWANDS SDN BHD, Malaysia's leading AI software development company. We specialize in AI governance, enterprise AI solutions, and custom AI systems for businesses across Malaysia and ASEAN."
        keywords="about EWANDS, AI company profile Malaysia, Malaysia AI software company, enterprise AI developer, AI governance experts Malaysia"
        canonicalPath={`/${language}/about`}
      />
      {/* Hero Section */}
      <section className="hero-section about-hero">
        <div className="hero-background">
          <div className="gradient-layer"></div>
          <div className="particle-layer"></div>
          <div className="grid-overlay"></div>
          <div className="tech-lines"></div>
        </div>
        
        <div className="hero-content">
          <div className="container">
            <div className="hero-wrapper">
              <div className="tech-element tech-element-1"></div>
              <div className="tech-element tech-element-4"></div>
              <div className="tech-element tech-element-5"></div>
              <h1 className="hero-quote">
                <span className="quote-highlight">{t('hero.title')}</span><br />
                {t('hero.subtitle1')}<br />
                {t('hero.subtitle2')}
              </h1>
              <p className="hero-subtitle fade-in" style={{ animationDelay: '0.2s' }}>
                {t('hero.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="capabilities-grid-section mb-5 pb-5">
        <div className="container">
          <div className="row gy-5">
            <div className="col-lg-6">
              <div className="capability-card-modern fade-in">
                <div className="card-tag">{t('content.core.tag')}</div>
                <h2 className="capability-title-bold">{t('content.core.title')}</h2>
                <div className="card-divider"></div>
                <p className="capability-desc-text">
                  {t('content.core.paragraph1')}
                </p>
                <p className="capability-desc-text mt-3">
                  {t('content.core.paragraph2')}
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="capability-card-modern fade-in" style={{ animationDelay: '0.2s' }}>
                <div className="card-tag">{t('content.mission.tag')}</div>
                <h2 className="capability-title-bold">{t('content.mission.title')}</h2>
                <div className="card-divider"></div>
                <div className="approach-item mb-3">
                  <h4 className="mb-1" style={{ fontWeight: 800 }}>{t('content.mission.deterministic.title')}</h4>
                  <p className="capability-desc-text">{t('content.mission.deterministic.description')}</p>
                </div>
                <div className="approach-item mb-3">
                  <h4 className="mb-1" style={{ fontWeight: 800 }}>{t('content.mission.sovereignty.title')}</h4>
                  <p className="capability-desc-text">{t('content.mission.sovereignty.description')}</p>
                </div>
                <div className="approach-item">
                  <h4 className="mb-1" style={{ fontWeight: 800 }}>{t('content.mission.synthesis.title')}</h4>
                  <p className="capability-desc-text">{t('content.mission.synthesis.description')}</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Full Width Frontier CTA Section */}
      <section className="enterprise-scale-cta-section" style={{
        width: '100%',
        background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(139, 92, 246, 0.08) 100%)',
        borderTop: '1px solid rgba(59, 130, 246, 0.2)',
        borderBottom: '1px solid rgba(59, 130, 246, 0.2)',
        padding: '5rem 0'
      }}>
        <div className="container">
          <div className="capability-card-modern fade-in" style={{ 
            textAlign: 'center', 
            animationDelay: '0.4s',
            background: 'transparent',
            border: 'none',
            padding: '2rem',
            boxShadow: 'none'
          }}>
            <div className="card-tag">{t('cta.tag')}</div>
            <h2 className="capability-title-bold" style={{ textAlign: 'center' }}>{t('cta.title')}</h2>
            <div className="card-divider" style={{ margin: '0 auto 2rem' }}></div>
            <p className="capability-desc-text" style={{ maxWidth: '900px', margin: '0 auto' }}>
              {t('cta.description')}
            </p>
            <div style={{ marginTop: '3rem', marginBottom: '3rem', display: 'flex', justifyContent: 'center' }}>
              <Link to={`/${language}/contact`} className="hero-cta" style={{ 
                fontSize: '1.25rem',
                padding: '1.5rem 3rem',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '1.5rem',
                border: '2px solid',
                borderRadius: '12px',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                backdropFilter: 'blur(10px)'
              }}>
                <span className="cta-chevrons" style={{ margin: 0 }}>
                  <span>›</span><span>›</span><span>›</span>
                </span>
                {t('cta.button')}
                <span className="cta-chevrons-reverse" style={{ margin: 0 }}>
                  <span>‹</span><span>‹</span><span>‹</span>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
